import React, {useEffect, useRef, useState} from "react";
import {
    Card,
    useTheme,
    useMediaQuery,
    Avatar,
    Typography,
    Button,
    MenuItem,
    withStyles, CardContent, Tooltip
} from "@material-ui/core";
import {usePrevious, useWindowSize} from "react-use";
import {faLightbulb, faMagic} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {green, grey, red} from "@material-ui/core/colors";
import AppColors from "../colors/AppColors";
import '../../src/App.css';
import {makeStyles} from "@material-ui/core";
import BoxSelect from "../views/BoxSelect";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {Constants} from "../constants/Constants";
import UsersManager from "../managers/UsersManager";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import ReactDOM from "react-dom";
import Ticket from "../models/Ticket";
import {GameType} from "../enums/GameType";
import TicketView from "../views/TicketView";
import AddIcon from "@material-ui/icons/Add";
import {useDispatch} from "react-redux";
import LiveStats from "./LiveStats";
import RequestUtils from "../utils/RequestUtils";
import StakeView from "./betConfigs/StakeView";
import MaximumProfitOnWinView from "./betConfigs/MaximumProfitOnWinView";
import RewardUtils from "../utils/RewardUtils";
import ExceptionUtils from "../utils/ExceptionUtils";
import LotteryWinningNumbersView from "../views/LotteryWinningNumbersView";
import ReactConfetti from "react-confetti";
import Games from "../constants/Games";
import GenUtils from "../utils/GenUtils";
import Game from "../models/Game";
import {animateScroll} from "react-scroll";
import HowToPlay from "../views/HowToPlay";

const useLotteryStyle = makeStyles((_theme) => ({
    addIcon: {
        color: 'white',
        fontSize: 40,
        fontWeight: 600,
        textAlign: 'center',
        borderRadius: 60,
        marginBottom: 8,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: AppColors.APP_BAR_BACKGROUND_COLOR
        }
    },
    playButton: {
        background: `linear-gradient(to bottom,mediumseagreen 5%,mediumseagreen 100%)`,
        color: AppColors.WHITE,
        fontWeight: 600,
        paddingLeft: 50,
        paddingRight: 50,
        paddingTop: 10,
        paddingBottom: 10,
        fontSize: 20,
        borderRadius: 2,
        '&:hover': {
            backgroundColor: green[700],
        }
    },
    digits: {
        width: 35,
        height: 35,
        marginRight: 15,
        marginBottom: 15,
        fontWeight: 600,
        color: AppColors.BLACK,
        cursor: 'pointer',
        backgroundColor: AppColors.WHITE,
        '&:hover': {
            backgroundColor: red[400],
        }
    },
    selectedDigit: {
        width: 35,
        height: 35,
        marginRight: 15,
        marginBottom: 15,
        fontWeight: 600,
        color: AppColors.BLACK,
        cursor: 'pointer',
        backgroundColor: red[400],
        '&:hover': {
            backgroundColor: red[400],
        }
    },
    luckyDigits: {
        backgroundColor: AppColors.GREEN,
        color: AppColors.WHITE,
        fontWeight: 600,
        width: 35,
        height: 35,
        marginRight: 7,
    },
    quickPickBtn: {
        fontWeight: 600,
        marginRight: 15,
        marginTop: 10,
        backgroundColor: AppColors.ACCENT_COLOR,
        color: AppColors.WHITE,
        transition: 'all .2s ease-in-out',
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.ACCENT_COLOR,
        },
    },
    selectMenuItem: {
        '&.Mui-selected:':
            {
                color: "#ffffff"
            }
    }
}));


const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const MultiplyBTC = React.forwardRef(function () {

        const classes = useLotteryStyle();
        const theme = useTheme();
        const {width} = useWindowSize();
        const belowSevenHundred = useMediaQuery(theme.breakpoints.down(700));
        const blackCardsCanGoFlat = useMediaQuery(theme.breakpoints.down(419));
        const [betType, setBetType] = useState(-1);
        const [numbersCount, setNumbersCount] = useState(0);
        const [openSnack, setOpenSnack] = useState(false);
        const [snackMessage, setSnackMessage] = useState("");
        const [snackSeverity, setSnackSeverity] = useState("warning");
        const [activeTicket, setActiveTicket] = useState<Ticket>(new Ticket());
        const [remountCount, setRemountCount] = useState(0);
        const [tickets, setTickets] = useState<Ticket[]>([]);
        const [nextTicketIndex, setNextTicketIndex] = useState(-1);
        const previousTickets = usePrevious<Ticket[]>(tickets);
        const [winningNumbers, setWinningNumbers] = useState<number[]>([]);
        const [wonAmount, setWonAmount] = useState<number | undefined>(undefined);
        const [lostAmount, setLostAmount] = useState<number | undefined>(undefined);
        const [resultsAnnounced, setResultsAnnounced] = useState(false);
        const [fetchingResults, setFetchingResults] = useState(false);
        const costPerTicketFieldRef = useRef<HTMLButtonElement | null>(null);
        const cardRef = useRef(null);
        const [noticeWidth, setNoticeWidth] = useState(-1);
        const gameNumbers = generateBluePrintNumbers();
        const [selectedIndex, setSelectedIndex] = useState(0);
        const [rolled, setRolled] = useState(true);
        const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
        const dispatch = useDispatch();
        const refresh = () => setRemountCount(remountCount + 1);
        const [game, setGame] = useState<Game>();
        const ticketsViewRef = useRef(null);
        const [numbersCompleteMsg, setNumbersCompleteMsg] = useState("");

        const scrollToRef = (ref: any) => {
            let refPosition: number = ref.current.offsetTop - 200;
            animateScroll.scrollTo(refPosition)
        }

        const addMoreTickets = () => {
            let newTicket = new Ticket();
            setTickets([...tickets, newTicket]);
        }

        const winningNumbersString = () => {
            let winningNumbersString = "";
            let tempWinningNumbers = winningNumbers;
            if (winningNumbers.length == 0) {
                tempWinningNumbers = [0, 0, 0, 0, 0, 0];
            }
            for (let winningNumber of tempWinningNumbers) {
                let winningNumberString = winningNumber.toString();
                if (winningNumberString.length < 2) {
                    winningNumberString = "0" + winningNumberString + ",";
                } else {
                    winningNumberString = winningNumberString + ",";
                }
                winningNumbersString = winningNumbersString + winningNumberString;
            }
            return winningNumbersString;
        }

        const displayProvablyFair = () => {
            dispatch({
                type: Constants.ACTION_DISPLAY_PROVABLY_FAIR_PAGE,
                payload: {
                    [Constants.PROVABLY_FAIR_INIT_DATA]: {
                        [Constants.OPEN]: true,
                        [Constants.ACTION_ORIGINATOR]: 1
                    }
                },
            });
        }

        const displayProvablyFairWithLocation = () => {
            dispatch({
                type: Constants.ACTION_DISPLAY_PROVABLY_FAIR_PAGE,
                payload: {
                    [Constants.PROVABLY_FAIR_INIT_DATA]: {
                        [Constants.OPEN]: true,
                        [Constants.ACTION_ORIGINATOR]: 1,
                        [Constants.SCROLL_TO_HOW]: true
                    }
                },
            });
        }

        const moveToVerificationPage = (game: Game) => {
            GenUtils.moveToVerificationPage(game);
        }

        useEffect(() => {
            if (previousTickets !== undefined) {
                if (tickets.length > previousTickets!.length) {
                    activeTicketController(tickets[tickets.length - 1]);
                    setNextTicketIndex(-1);
                }
                dispatch({
                    type: Constants.TICKETS_CHANGED,
                    payload: {
                        [Constants.TICKETS]: tickets
                    }
                });
            }
            if (nextTicketIndex !== -1) {
                activeTicketController(tickets[nextTicketIndex]);
            }
        }, [tickets]);

        const handleSnackClose = () => {
            setOpenSnack(false);
        }

        const snackError = (message: string) => {
            setSnackMessage(message);
            setSnackSeverity("error");
            setOpenSnack(true);
        }

        function generateBluePrintNumbers() {
            const numbers = [];
            let len = Constants.BASE_NUMBER + 1;
            for (let i = 1; i < len; i++) {
                numbers.push(i);
            }
            return numbers;
        }

        const activeTicketController = (ticket: Ticket) => {
            setActiveTicket(ticket);
            setSelectedIndex(tickets.indexOf(ticket));
        }

        const validTicketsDetected = () => {
            return tickets.length > 0 && tickets[0].numbers!.length > 0;
        }

        const clearExistingTickets = () => {
            for (let i = 0; i < tickets.length; i++) {
                tickets.splice(i, 1);
            }
            if (activeTicket?.numbers?.length) {
                for (let i = 0; i < activeTicket.numbers.length; i++) {
                    activeTicket.numbers.splice(i, 1);
                }
            }
            let newTicket = new Ticket();
            setTickets([...tickets, newTicket]);
            setSelectedIndex(0);
        }

        const removeFromTickets = (ticket: Ticket) => {
            let indexOfTicket = tickets.indexOf(ticket);
            let nextIndex = indexOfTicket - 1 < 0 ? 0 : indexOfTicket - 1;
            tickets.splice(indexOfTicket, 1);
            setTickets([...tickets]);
            if (tickets.length > 0) {
                setNextTicketIndex(nextIndex);
            }
            if (tickets.length == 0) {
                clearExistingTickets();
            }
        }

        const handleGameTypeChange = (event: any) => {
            let gameSelection = event.target.value;
            if (gameSelection != -1) {
                clearExistingTickets();
                setNumbersCount(gameSelection + 2);
                setBetType(gameSelection);
                dispatch({
                    type: Constants.BET_TYPE_CHANGED,
                    payload: {
                        [Constants.BET_TYPE]: gameSelection
                    }
                })
            }
        }

        const WonFeedBackView = () => {
            return <CardContent style={{
                backgroundColor: AppColors.GREEN,
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                borderRadius: 2
            }}>
                <Typography
                    style={{
                        marginTop: 5
                    }}
                    dangerouslySetInnerHTML={{__html: `<b>Congratulations!</b> You won <b>${wonAmount?.toFixed(8)}</b> BTC!!!`}}/>
            </CardContent>
        }

        const ErrorFeedBackView = () => {
            return <CardContent style={{
                backgroundColor: red[500],
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                borderRadius: 2
            }}>
                <Typography
                    style={{
                        marginTop: 5
                    }}
                    dangerouslySetInnerHTML={{__html: `${errorMessage}`}}/>
            </CardContent>
        }

        const LostFeedBackView = () => {
            return <CardContent style={{
                backgroundColor: red[500],
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                borderRadius: 2,
                width:'50%',
                maxWidth:'50%'
            }}>
                <Typography
                    style={{
                        marginTop: 5,
                        textAlign:'center'
                    }}
                    dangerouslySetInnerHTML={{__html: `<b>Sorry!</b> All numbers Per Ticket were <b>NOT</b> drawn and so you lost <b>${lostAmount!!.toFixed(8)}</b> BTC`}}/>
            </CardContent>
        }

        const playGame = () => {
            setLostAmount(undefined);
            setWonAmount(undefined);
            setErrorMessage(undefined);
            for (let ticket of tickets) {
                if (!ticket.numbers?.length) {
                    snackError("Pick Your numbers");
                    return;
                }
            }
            for (let ticket of tickets) {
                if (ticket.numbers!.length < numbersCount) {
                    snackError("One of your ticket numbers are incomplete");
                    return;
                }
            }
            const costPerTicket = (costPerTicketFieldRef.current as any).value;
            if (!costPerTicket) {
                snackError("Enter how much you would like to stake per ticket");
                (costPerTicketFieldRef.current as HTMLButtonElement).focus();
                return;
            }
            setRolled(false);
            setResultsAnnounced(false);
            setFetchingResults(true);
            let loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string);
            let postData = {
                costPerTicket: parseFloat(costPerTicket),
                tickets: tickets,
                gameType: GameType.SIX_FORTY_NINE,
                betType: betType,
                clientSeed: localStorage.getItem(Constants.USER_CLIENT_SEED) ?? loggedInUser.activeClientSeed
            };
            axios.post(EndPoints.NEW_GAME,
                postData, {
                    headers: RequestUtils.getHeaders()
                }).then(data => {
                // noinspection DuplicatedCode
                let responseData = data["data"]["data"];
                let game = responseData["game"];
                setGame(game);
                let user = responseData["user"];
                UsersManager.saveLoggedInUser(JSON.stringify(user));
                dispatch({
                    type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                    payload: JSON.stringify(user)
                });
                let wonAmount = game["wonAmount"];
                if (wonAmount > 0) {
                    setWonAmount(wonAmount);
                }
                let lostAmount = game["lostAmount"];
                if (lostAmount > 0) {
                    setLostAmount(lostAmount);
                }
                let winningNumbers = game["winningNumbers"];
                setWinningNumbers(winningNumbers);
                setRolled(true);
                setResultsAnnounced(true);
                setFetchingResults(false);
                UsersManager.setHasRolled();
            }).catch(error => {
                setRolled(true);
                let message = ExceptionUtils.getErrorMessage(error, "Error drawing results. Please try again");
                setFetchingResults(false);
                setErrorMessage(message);
            });
        }

        const handleNumberClicked = (clickedNumber: any) => {
            updateActiveTicketNumbers(clickedNumber);
        }

        const generateRandomNumber = (): number => {
            let randomNumber = Math.floor(Math.random() * Constants.BASE_NUMBER) + 1;
            if (activeTicket?.numbers?.includes(randomNumber)) {
                return generateRandomNumber();
            }
            return randomNumber;
        }

        const generateMagicNumbers = () => {
            if (activeTicket?.numbers?.length) {
                activeTicket.numbers = [];
                refresh();
                return;
            }
            for (let i = 0; i < numbersCount; i++) {
                let randomNumber = generateRandomNumber();
                activeTicket?.numbers?.push(randomNumber);
            }
            refresh();
            scrollToRef(ticketsViewRef);
        }

        const updateActiveTicketNumbers = (pickedNumber: any) => {
            if (betType === -1) {
                snackError("Please select a game first");
                return;
            }
            if (!activeTicket?.numbers?.includes(pickedNumber)) {
                if (activeTicket!.numbers!.length < numbersCount) {
                    activeTicket!.numbers?.push(pickedNumber);
                    refresh();
                } else {
                    setNumbersCompleteMsg("Numbers complete. Deselect one of your chosen numbers before choosing this one")
                    setTimeout(() => {
                        setNumbersCompleteMsg("");
                    }, 20000);
                }
            } else {
                let indexOfSelection = activeTicket?.numbers?.indexOf(pickedNumber);
                activeTicket?.numbers?.splice(indexOfSelection, 1);
                refresh();
            }
        }

        const updateNoticeWidth = () => {
            const rect1 = (ReactDOM.findDOMNode(cardRef.current) as HTMLDivElement).getBoundingClientRect();
            if (noticeWidth !== rect1.width) {
                setNoticeWidth(rect1.width);
            }
        }

        function resizeHandler() {
            updateNoticeWidth();
        }

        useEffect(() => {
            window.addEventListener('resize', resizeHandler);
            return () => {
                window.removeEventListener('resize', resizeHandler);
            }
        });

        useEffect(() => {
            updateNoticeWidth();
        }, [noticeWidth]);

        const SelectedTicketsAndMoreView = () => {
            return <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                }}>{
                    tickets.map((ticket, index) => {
                        return <TicketView
                            key={index}
                            ref={ticketsViewRef}
                            winningNumbers={winningNumbers}
                            numbersCount={numbersCount}
                            ticket={ticket}
                            selected={index === selectedIndex}
                            activeTicketController={activeTicketController}
                            removeFromTickets={removeFromTickets}/>
                    })
                }
                </div>
                {
                    validTicketsDetected() &&
                    <LightTooltip placement={"top"} title={"Add More tickets(Optional)"}>
                        <AddIcon className={classes.addIcon} onClick={addMoreTickets}/>
                    </LightTooltip>
                }
            </div>
        }

        const LottoCompareView = () => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                flexWrap: 'wrap',
                alignItems: 'center',
                padding: 10,
                width: noticeWidth,
            }}>
                <Typography
                    style={{
                        fontSize: 13,
                        color: grey[300],
                        textAlign: 'center',
                        alignSelf: 'center',
                        lineHeight: '1.6',
                    }}
                    dangerouslySetInnerHTML={{__html: `Unlike Conventional Lottery Systems where you are bound to be cheated, this game is `}}/>
                <Typography
                    onClick={displayProvablyFair}
                    style={{
                        color: AppColors.CYAN,
                        paddingLeft: 5,
                        fontSize: 13,
                        cursor: 'pointer',
                        textTransform: 'none'
                    }}>Provably Fair</Typography>
                <Typography
                    style={{
                        fontSize: 13,
                        color: grey[300],
                        textAlign: 'center',
                        alignSelf: 'center',
                        lineHeight: '1.6',
                    }}
                    dangerouslySetInnerHTML={{__html: `and the draws are instant. <br/>The System can never cheat you as you can always verify your games.`}}/>
            </div>
        }

        // noinspection JSUnusedLocalSymbols
        const VerifyView = React.forwardRef(function (props: any, ref: any) {
            return <Typography
                align={"center"}
                onClick={() => moveToVerificationPage(props.game)}
                style={{
                    textDecoration: 'none',
                    color: AppColors.CYAN,
                    paddingTop: 5,
                    cursor: 'pointer',
                    paddingBottom: 5
                }}>VERIFY</Typography>
        });

        const ConfettiView = () => {
            return <ReactConfetti
                height={2000}
                width={width}
                initialVelocityY={500}
            />
        }

        return (
            <div style={{
                display: 'flex',
                marginTop: 20,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <img src={require('../images/multiply_btc.png')}
                         style={{
                             alignSelf: 'center',
                         }} alt={"Multiply Bitcoin"}/>
                    <Typography align={"center"} style={{
                        color: AppColors.lightenOrDarken("#FF9900", 10),
                        fontSize: 20
                    }}>Win BIG in Our Instant (6/{Constants.BASE_NUMBER - 1}) Game</Typography>
                    <Card
                        style={{
                            alignSelf: 'center',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            display: 'flex',
                            padding: belowSevenHundred ? 5 : 10,
                            margin: 10,
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 20,
                            borderRadius: blackCardsCanGoFlat ? 0 : belowSevenHundred ? 80 : 60,
                            backgroundColor: AppColors.BLACK
                        }}>
                        <FontAwesomeIcon icon={faLightbulb} style={{
                            color: AppColors.ACCENT_COLOR,
                            flexGrow: 1,
                            fontSize: 20,
                            marginLeft: 10,
                        }}/>
                        <Typography style={{
                            flexGrow: 1,
                            textAlign: 'center',
                            padding: 10,
                            fontSize: belowSevenHundred ? 16 : 18,
                            color: grey[300]
                        }}
                                    dangerouslySetInnerHTML={{__html: `<span style='color:${grey[300]}'>Select a Game and Pick your numbers to Play`}}/>
                    </Card>
                </div>
                <div style={{
                    display: 'flex',
                    paddingTop: 10,
                    flexDirection: 'row',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: 20,
                    alignItems: 'center'
                }}>
                    <Typography
                        style={{
                            fontSize: 16,
                            color: grey[300],
                            textAlign: 'center',
                            alignSelf: 'center',
                            lineHeight: '1.6',
                        }}>This Game is </Typography>
                    <Typography
                        onClick={displayProvablyFair}
                        style={{
                            color: AppColors.CYAN,
                            paddingLeft: 5,
                            fontSize: 16,
                            cursor: 'pointer',
                            textTransform: 'none'
                        }}>Provably Fair</Typography>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexWrap: 'wrap'
                    }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}>
                        <HowToPlay/>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: width > 600 ? 600 : width - 100,
                        }}>
                            <Card
                                ref={cardRef}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundColor: AppColors.CARD_BACKGROUND_COLOR,
                                    padding: 10,
                                    alignSelf: 'center',
                                    width:'98%',
                                    justifyContent: 'center',
                                    transition: 'all .5s ease-out',
                                    paddingLeft: 20,
                                }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row',
                                    width:'100%',
                                    flexWrap: 'wrap'
                                }}>
                                    <BoxSelect
                                        labelId="game-selector-label"
                                        id="game-selector"
                                        value={betType}
                                        style={{
                                            marginTop: 10
                                        }}
                                        onChange={handleGameTypeChange}>
                                        <MenuItem value={-1} disabled>
                                            <b style={{
                                                color: grey[900]
                                            }}>SELECT A GAME</b>
                                        </MenuItem>
                                        <MenuItem value={0}>
                                            <b> {Games.TWO_HITS}</b>
                                        </MenuItem>
                                        <MenuItem value={1}>
                                            <b>{Games.THREE_HITS}</b>
                                        </MenuItem>
                                        <MenuItem value={2}>
                                            <b>{Games.FOUR_HITS}</b>
                                        </MenuItem>
                                        <MenuItem value={3}>
                                            <b>{Games.FIVE_HITS}</b>
                                        </MenuItem>
                                        <MenuItem value={4}>
                                            <b>{Games.SIX_HITS}</b>
                                        </MenuItem>
                                    </BoxSelect>
                                    {
                                        betType !== -1 &&
                                        <Button className={classes.quickPickBtn}
                                                size={"small"}
                                                onClick={generateMagicNumbers}>Quick Pick
                                            {
                                                <FontAwesomeIcon icon={faMagic}
                                                                 style={{
                                                                     color: AppColors.WHITE,
                                                                     fontSize: 20,
                                                                     marginLeft: 10,
                                                                 }}/>
                                            }</Button>
                                    }
                                </div>
                                {
                                    betType !== -1 &&
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <Typography
                                            style={{
                                                marginLeft: 5,
                                                marginTop: 15,
                                                fontWeight: 400, color: AppColors.EASE_GRAY
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    `Predict <b>${numbersCount}</b> numbers and WIN <b style='color:#F1952D'>${RewardUtils.GameRewards["" + betType]} * Your Stake Amount</b> if they are ALL drawn from your unique server seed`
                                            }}/>
                                        <Typography
                                            onClick={displayProvablyFairWithLocation}
                                            style={{
                                                color: AppColors.CYAN,
                                                paddingLeft: 5,
                                                fontSize: 13,
                                                cursor: 'pointer',
                                                textTransform: 'none'
                                            }}>Learn How</Typography>
                                    </div>
                                }
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: 15,
                                        flexWrap: 'wrap',
                                    }}>
                                    {
                                        gameNumbers.map((number) => {
                                            return <Avatar
                                                key={number}
                                                className={
                                                    activeTicket?.numbers?.includes(number)
                                                        ? classes.selectedDigit : classes.digits
                                                }
                                                onClick={() => handleNumberClicked(number)}>
                                                {number}
                                            </Avatar>
                                        })
                                    }
                                </div>
                                {
                                    numbersCompleteMsg !== "" &&
                                    <Typography
                                        style={{
                                            color: AppColors.GREY_TEXT,
                                            textAlign: 'center',
                                            fontSize: 14
                                        }}
                                        align={"center"}>{numbersCompleteMsg}
                                    </Typography>
                                }
                                <div
                                    style={{
                                        marginTop: 20,
                                        display: 'flex',
                                        width: '100%',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap',
                                    }}>
                                    <SelectedTicketsAndMoreView/>
                                    {
                                        betType !== -1 && validTicketsDetected() &&
                                        <StakeView ref={costPerTicketFieldRef}/>
                                    }
                                    {
                                        betType !== -1 && costPerTicketFieldRef.current?.value &&
                                        <MaximumProfitOnWinView/>
                                    }
                                    {
                                        betType !== -1 &&
                                        <LotteryWinningNumbersView
                                            roll={winningNumbersString()}
                                            rolled={rolled}
                                            tickets={tickets}
                                        />
                                    }
                                    {
                                        resultsAnnounced && !fetchingResults &&
                                        <VerifyView game={game}/>
                                    }
                                    {
                                        resultsAnnounced && !fetchingResults && wonAmount &&
                                        <WonFeedBackView/>
                                    }
                                    {
                                        resultsAnnounced && !fetchingResults && lostAmount &&
                                        <LostFeedBackView/>
                                    }
                                    {
                                        errorMessage &&
                                        <ErrorFeedBackView/>
                                    }
                                    <Button className={classes.playButton}
                                            disabled={betType === -1 || fetchingResults}
                                            onClick={playGame}>PLAY</Button>
                                </div>
                            </Card>
                            <LottoCompareView/>
                        </div>
                    </div>
                </div>
                <LiveStats gameType={1}/>
                <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                                  severity={snackSeverity}/>
                {
                    resultsAnnounced && !fetchingResults && wonAmount &&
                    <ConfettiView/>
                }
            </div>
        );
    }
);

export default MultiplyBTC;